export const en = {
    campaignCreated: 'Campaign created',
    hasModeration: 'submit the campaign for moderation',
    hasMoney: 'make sure that there is money in the shared account',
    later: 'Later',
    sendToModeration: 'Submit for moderation',
    showConditions: 'To start serving ads in this campaign:'
};
